import { ajuste_estimativa_de_matricula_reordenamento_sem_continuidade } from "./ajuste-estimativa-de-matricula-reordenamento-sem-continuidade";
import { ajuste_estimativa_de_matricula_reordenamento_mudanca_de_perfil } from "./ajuste-estimativa-de-matricula-reordenamento-mudanca-de-perfil";

const ajuste_estimativa_de_matricula_reordenamento = [
  ajuste_estimativa_de_matricula_reordenamento_sem_continuidade,
  ajuste_estimativa_de_matricula_reordenamento_mudanca_de_perfil,
];

export { ajuste_estimativa_de_matricula_reordenamento };
